import { titleCase } from '~app/shared/functions/utils/utils.function';

export class Port {
  private readonly data: {
    code: string;
    name: string;
    type: string;
    country: string;
    airport: string;
    timezoneOffsetEST: string;
  };

  constructor(data: any) {
    this.data = data;
  }

  public get code(): string {
    return this.data.code;
  }

  public get name(): string {
    return titleCase(this.data.name);
  }
}
